

const handleSubmission = async(data, setPage) => {
    try {
        const response = await fetch('https://l9xh3pffug.execute-api.us-west-2.amazonaws.com/api/webflow-form-submission', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': '0UTU3GgRoD4I6n7be0tqfaypqNddr1Z43TL1Wbha'
            },
            body: JSON.stringify(data)
        });

        // Debug: Log API response
        // Parse API response
        const responseData = await response.json();

        if(responseData.statusCode === 200){
            setPage("success")
            try{
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'formSubmissionSuccess',
                    'formType': 'contactForm', // Replace with your form's name or type
                });
            }catch(e){

            }
            return 200
        } else if (responseData.statusCode === 409){
            return 409
        } else {
            return
        }
    }
    catch(e){
        return
    }


}

export default handleSubmission